module.exports = __webpack_public_path__ + "static/media/iconSectionInstallation.f534cded.svg";